import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';

import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { ForeignKey } from '@totem/types/common';
import { sortStringAscending } from '@totem/utilities/tableUtilities';

type Props = {
  keys: ForeignKey[];
  onDelete?: (key: ForeignKey) => void;
};

const KeysTable = ({ keys, onDelete }: Props) => {
  const columns: ColumnProps<ForeignKey>[] = [
    {
      title: 'System',
      dataIndex: 'system',
      key: 'system',
      defaultSortOrder: 'ascend',
      sorter: (compA, compB) => sortStringAscending(compA.system, compB.system),
    },
    {
      title: 'Instance',
      dataIndex: 'instance',
      key: 'instance',
      sorter: (compA, compB) =>
        sortStringAscending(compA.instance, compB.instance),
    },
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
      sorter: (compA, compB) => sortStringAscending(compA.key, compB.key),
    },
    {
      title: 'Created By',
      dataIndex: 'createdByName',
      key: 'createdByName',
      sorter: (compA, compB) =>
        sortStringAscending(compA.createdByName, compB.createdByName),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (compA, compB) =>
        sortStringAscending(compA.createdAt, compB.createdAt),
    },
  ];

  if (onDelete) {
    columns.push({
      title: '',
      key: 'actions',
      width: 60,
      render: (_, record) => (
        <Tooltip title="Delete key">
          <Popconfirm
            title="Delete this key?"
            description={`${record.system} / ${record.instance} / ${record.key}`}
            okText="Delete"
            okType="danger"
            cancelText="Cancel"
            onConfirm={() => onDelete(record)}
          >
            <Button
              danger
              icon={<DeleteOutlined />}
              disabled={
                !record.createdByName
                  .toLowerCase()
                  .endsWith('@intelligentbuildings.com')
              }
              shape="circle"
            />
          </Popconfirm>
        </Tooltip>
      ),
    });
  }

  return (
    <IBTable
      showSorterTooltip
      columns={columns}
      dataSource={keys}
      loading={false}
      pagination={{ showSizeChanger: true }}
      rowKey={(record) => record.system + record.instance + record.key}
    />
  );
};

export default KeysTable;
